import { makeElementCreator } from "@qdabra/build-xml";
import { find, map, propEq } from "ramda";

const taxElement = makeElementCreator('http://schemas.microsoft.com/sharepoint/taxonomy/soap/');

const tl = (dom, term) =>
    taxElement(
        dom,
        'TL',
        {
            attributes: {
                a31: 'true',
                a32: term.name,
            },
        }
    );

const td = (dom) =>
    taxElement(
        dom,
        'TD',
        {
            attributes: {
                a11: '',
            },
        },
    );

const findTermById = (id, termSet) => find(
    propEq('id', id),
    termSet.terms,
);

const getParentIds = (termSet, { id, isRoot, parentId }) => {
    if (isRoot) {
        return [id];
    }

    return [
        ...getParentIds(
            termSet,
            findTermById(parentId, termSet),
        ),
        id,
    ];
};

const tm = (dom, termSet, term) =>
    taxElement(
        dom,
        'TM',
        {
            attributes: {
                a12: termSet.name,
                a17: 'true',
                a24: termSet.id,
                ...(term.isRoot ? null : { a25: term.parentId }),
                a40: term.parentPath,
                a45: getParentIds(termSet, term).join(';'),
                a67: '',
                a69: 'true',
            }
        }
    );

const ls = (dom, term) =>
    taxElement(
        dom,
        'LS',
        {
            children: [
                tl(dom, term)
            ]
        }
    );

const ds = (dom) =>
    taxElement(
        dom,
        'DS',
        {
            children: [td(dom)],
        }
    );

const tms = (dom, termSet, term) =>
    taxElement(
        dom,
        'TMS',
        {
            children: [tm(dom, termSet, term)],
        },
    );

const t = (dom, termSet) => (term) =>
    taxElement(
        dom,
        'T',
        {
            attributes: {
                a9: term.id,
                a21: 'false',
                a61: '0',
            },
            children: [
                ls(dom, term),
                ds(dom),
                tms(dom, termSet, term),
            ],
        }
    );

const ts = (dom, termSet) =>
    taxElement(
        dom,
        'TS',
        {
            attributes: {
                a9: termSet.id,
                a11: '',
                a12: termSet.name,
                a16: 'false',
                a17: 'true',
                a68: '',
            },
        }
    );

const termStore = (dom) => (termSet) =>
    taxElement(
        dom,
        'TermStore',
        {
            children: [
                ts(dom, termSet),
                ...map(
                    t(dom, termSet),
                    termSet.terms,
                ),
            ]
        }
    );

const container = (dom, termSets) =>
    taxElement(
        dom,
        'Container',
        {
            children: map(
                termStore(dom),
                termSets,
            ),
        },
    );

const makeEmptyDoc = () => {
    let doc = $.parseXML('<n />');
    doc.removeChild(doc.documentElement);
    return doc;
};

const buildTermSetsDoc = (termSets) => {
    const dom = makeEmptyDoc();

    dom.appendChild(container(dom, termSets));

    return dom;
};

export {
    buildTermSetsDoc,
};